import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class SaveLeadUseCase extends BaseUseCase {
    constructor(saveLeadRepo) {
        super();
        this.saveLeadRepo = saveLeadRepo;
    }
    async fetchResult(req) {
        return await this.saveLeadRepo.saveLeadData(req);
    }
}
export default SaveLeadUseCase;
